import * as jsonpointer from "jsonpointer";
import { cleanRef } from "./clean-ref.js";
function getContentByRef(ref, pageModel, refPrefix) {
  if (!ref || !pageModel) {
    return void 0;
  }
  const parsedRef = cleanRef(ref, refPrefix);
  return jsonpointer.get(pageModel, parsedRef);
}
export {
  getContentByRef
};
//# sourceMappingURL=get-content-by-ref.js.map
